//import BaseStore from './BaseStore'
import EventEmitter from 'events'

import * as ActionConstants from '../constants/'

import AppDispatcher from '../dispatcher/AppDispatcher';

const CHANGE_EVENT = 'change';

let appState = {
    isLoading: false
};


class ChartsStoreClass extends EventEmitter {


  addChangeListener(cb) {
    this.on(CHANGE_EVENT, cb);
  }


  emitChange() {
    this.emit(CHANGE_EVENT);
  }


  removeChangeListener(cb) {
    this.removeListener(CHANGE_EVENT,cb);
  }


  isLoading() {
    return appState.isLoading;
  }


 }

var ChartsStore = new ChartsStoreClass();


// Register callback with AppDispatcher
AppDispatcher.register((payload) => {

    let action = payload.action.actionType;

    switch(action) {

      case ActionConstants.REQ_DATA: {
        appState.isLoading=true;
        ChartsStore.emitChange();
      }
      break;

      case ActionConstants.RES_DATA: {
        appState.isLoading=false;
        ChartsStore.emitChange();
      }
      break;

      default:
	     break;
     }

  // If action was responded to, emit change event


  return true;

});


export default ChartsStore;



// WEBPACK FOOTER //
// ./src/store/ChartsStore.js